import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const TabBar = ({
  items, rounded
}) => {
  let path = window.location.hash.split('#')[1].split('?_')[0];
  return (
    <div className={`TabBar${rounded ? ` TabBarRounded` : ''}`}>
      <ul>
        {items && items.map(({ label, to, onlyActiveOnIndex, isVisible = true }) => (
          <li key={to} style={{ display: isVisible ? 'visible' : 'none' }} className={(onlyActiveOnIndex ? path === to : path.indexOf(to) === 0) ? 'active' : ''}>
            <Link to={to} onlyActiveOnIndex={onlyActiveOnIndex}>
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
};

TabBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onlyActiveOnIndex: PropTypes.boolean,
    })
  ).isRequired,
};

export default TabBar;



// WEBPACK FOOTER //
// ./src/components/TabBar.js